import {
  getResourceTypeString,
  isResourceType,
  ResourceTypeEnum,
} from "./ResourceTypeEnum";
import dictionary from "../langs.json";

export enum ModuleResourceTypeEnum {
  Presentation = ResourceTypeEnum.Presentation,
  Video = ResourceTypeEnum.Video,
  MaterialForStudent = ResourceTypeEnum.MaterialForStudent,
  Scenario = ResourceTypeEnum.Scenario,
  MiniGame,
  Task,
}

export const AllModuleResourceTypes: ModuleResourceTypeEnum[] = [
  ModuleResourceTypeEnum.Presentation,
  ModuleResourceTypeEnum.Video,
  ModuleResourceTypeEnum.MaterialForStudent,
  ModuleResourceTypeEnum.Scenario,
  ModuleResourceTypeEnum.MiniGame,
  ModuleResourceTypeEnum.Task,
];

export let getModuleResourceTypeString = (
  moduleResourceTypeId: ModuleResourceTypeEnum
): string => {
  if (isResourceType(moduleResourceTypeId))
    return getResourceTypeString(moduleResourceTypeId);
  else {
    return dictionary.ru.translation[
      ("moduleResourceType" +
        moduleResourceTypeId) as keyof typeof dictionary.ru.translation
    ];
  }
};
